import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";

const ReportSidebar = ({variant = "card" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get active folder from URL
  const params = new URLSearchParams(location.search);
  const activeFolder = params.get("folder") || "BOOKING";

  const handleFolderChange = (folder) => {
    navigate(`/reports?folder=${folder}`);
  };

  const menuContent = (
    <ul className={variant === "submenu" ? "sidebar-submenu" : "report-menu"}>
      <SidebarItem
        label="Booking reports"
        icon="mdi:calendar-check"
        active={activeFolder === "BOOKING"}
        onClick={() => handleFolderChange("BOOKING")}
      />

      <SidebarItem
        label="Expenses reports"
        icon="mdi:currency-usd"
        active={activeFolder === "EXPENSES"}
        onClick={() => handleFolderChange("EXPENSES")}
      />

      <SidebarItem
        label="Inventory reports"
        icon="mdi:warehouse"
        active={activeFolder === "INVENTORY"}
        onClick={() => handleFolderChange("INVENTORY")}
      />

      <SidebarItem
        label="Commission reports"
        icon="mdi:percent"
        active={activeFolder === "COMMISSION"}
        onClick={() => handleFolderChange("COMMISSION")}
      />

    </ul>
  );

  // If used inside MasterLayout submenu
  if (variant === "submenu") return menuContent;

  // Default card layout (if ever needed in page)
  return (
    <div className="email-sidebar email-sidebar-wrapper">
      <div className="card h-100 p-0">
        <div className="card-body responsive-menu p-24">
          {menuContent}
        </div>
      </div>
    </div>
  );
};

export default ReportSidebar;

/* -------- Reusable Item Component -------- */
const SidebarItem = ({ icon, label, count, active, onClick }) => {
  return (
    <li className={`mb-4 ${active ? "item-active" : ""}`}>
      <button
        onClick={onClick}
        className="bg-hover-primary-50 px-12 py-8 w-100 radius-8 text-secondary-light border-0 bg-transparent text-start"
      >
        <span className="d-flex align-items-center gap-10 justify-content-between w-100">
          <span className="d-flex align-items-center gap-10">
            <span className="icon text-xxl line-height-1 d-flex">
              <Icon icon={icon} className="icon line-height-1" />
            </span>
            <span className="fw-semibold">{label}</span>
          </span>
        </span>
      </button>
    </li>
  );
};